import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { Fade, IconButton, Paper } from '@mui/material';
import MDBox from 'components/MDBox';
import Lottie from 'react-lottie-player';
import errorEngine from 'assets/animation/errorEngine.json';
import MDTypography from 'components/MDTypography';
import { useIntl } from 'react-intl';
import PageLayout from 'components/LayoutContainers/PageLayout';
import Tooltip from '@mui/material/Tooltip';
import { useAuth } from 'hook/useAuth';
import LogoutIcon from '@mui/icons-material/Logout';

export default function Error() {
  const { formatMessage: msg } = useIntl();
  const location = useLocation();
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
  };

  const defaultState = {
    messageId: 'error.message.default',
    titleId: 'error.title.default',
    code: -1
  };

  const { messageId, titleId, code } = { ...defaultState, ...location.state };
  return (
    <PageLayout title={msg({ id: 'error.default' })} display="flex">
      <Fade in timeout={(1000, 500)}>
        <MDBox
          flex={1}
          display="flex"
          sx={{
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%'
          }}
        >
          <Paper
            display="flex"
            elevation={24}
            sx={{
              borderRadius: '30px',
              position: 'relative'
            }}
          >
            {code >= 400 && code < 404 ? (
              <IconButton
                id="logoutBtn"
                color="text"
                variant="contained"
                onClick={handleLogout}
                aria-label={msg({ id: 'action.logout' })}
                sx={{ position: 'absolute', right: '5px' }}
              >
                <Tooltip title={msg({ id: 'action.logout' })}>
                  <LogoutIcon sx={{ marginLeft: 'auto', textAlign: 'right' }} fontSize="large" />
                </Tooltip>
              </IconButton>
            ) : null}
            <MDBox
              display="flex"
              flexDirection={{ xs: 'column', xl: 'row' }}
              sx={{ alignItems: 'center' }}
              p={3}
            >
              <Lottie
                animationData={errorEngine}
                style={{ width: 400 }}
                speed={0.5}
                loop={false}
                play
              />
              <MDBox
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: { sx: '400px', xl: '600px' },
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <MDTypography variant="h2" color="error" mb={2}>
                  {msg({ id: titleId })}
                </MDTypography>
                <MDTypography sx={{ textAlign: 'center', fontStyle: 'italic' }}>
                  {msg({ id: messageId })}
                </MDTypography>
              </MDBox>
            </MDBox>
          </Paper>
        </MDBox>
      </Fade>
    </PageLayout>
  );
}
